<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="openAdd()"
        >添加</el-button
      >
      <el-button type="danger" size="mini" @click="open"
        >删除</el-button
      >
      <el-button
        type="success"
        size="mini"
        @click="getRoleinfo"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1471px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50"/>
      <el-table-column prop="address" label="操作" width="160">
        <template slot-scope="scope">
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="edit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="importWallet(scope.row)"
            >导入钱包</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="address" label="address" width="350" />
      <el-table-column prop="memo" label="备注" width="200" />
      <el-table-column prop="state" label="是否归集账号" width="100">
        <template slot-scope="scope">
          <span :style="scope.row.isGuiji ? 'color:#00c759' : 'color:red'">{{ scope.row.isGuiji ? "是" : "否"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="是否转出账号" width="100">
        <template slot-scope="scope">
          <span :style="scope.row.isZhuanchu ? 'color:#00c759' : 'color:red'">{{ scope.row.isZhuanchu ? "是" : "否"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="是否自动转出USDT" width="100">
        <template slot-scope="scope">
          <span :style="scope.row.isAutoZhuan ? 'color:#00c759' : 'color:red'">{{ scope.row.isAutoZhuan ? "是" : "否"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="是否自动转出提现TRX" width="100">
        <template slot-scope="scope">
          <span :style="scope.row.isZhuanWithdrawTrx ? 'color:#00c759' : 'color:red'">{{ scope.row.isZhuanWithdrawTrx ? "是" : "否"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="是否转出激活TRX" width="100">
        <template slot-scope="scope">
          <span :style="scope.row.isZhuanTrx ? 'color:#00c759' : 'color:red'">{{ scope.row.isZhuanTrx ? "是" : "否"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="是否代理能量" width="100">
        <template slot-scope="scope">
          <span :style="scope.row.isDailiEnergy ? 'color:#00c759' : 'color:red'">{{ scope.row.isDailiEnergy ? "是" : "否"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="创建时间" width="170" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getRoleinfo"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="add_dialogVisible"
      width="570px"
      title="添加"
      :center='true'
      :show-close='false'
      :close-on-click-modal="true"
      :before-close="handleClose"
      @closed="handleClose"
    >
      <div style="position: absolute;top: 21px;right: 15px;">
        <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="genNew()"
        >生成新号</el-button
      >
      </div>
      <!-- 添加用户表格 -->
      <el-form
        ref="addform"
        :model="addform"
        label-width="90px"
      >
        <el-form-item label="address">
          <el-input v-model="addform.address" placeholder="请输入address" type="text"/>
        </el-form-item>
         <el-form-item label="privateKey">
          <el-input v-model="addform.privateKey" placeholder="请输入privateKey" type="text"/>
        </el-form-item>
         <el-form-item label="hexAddress">
          <el-input v-model="addform.hexAddress" placeholder="请输入hexAddress" type="text"/>
        </el-form-item>
        <el-form-item label="publicKey">
          <el-input v-model="addform.publicKey" placeholder="请输入publicKey" type="text"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addform.memo" placeholder="请输入备注" type="text"/>
        </el-form-item>
        <el-form-item label="设置" prop="isEnabled">
          <el-checkbox v-model="isGuiji">是否归集账号</el-checkbox>
          <el-checkbox v-model="isZhuanchu">是否转出账号</el-checkbox>
          <el-checkbox v-model="isAutoZhuan">是否自动转出USDT</el-checkbox>
          <el-checkbox v-model="isZhuanTrx">是否转出激活TRX</el-checkbox>
          <el-checkbox v-model="isDailiEnergy">是否代理能量</el-checkbox>
          <el-checkbox v-model="isZhuanWithdrawTrx">否自动转出提现TRX</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="edit-button"
            :loading="buttongLoding"
            @click="addManagement"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 编辑用户弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="570px"
      title="编辑"
      :center='true'
      :close-on-click-modal="false"
      @closed="editClose"
    >
      <!-- 添加用户表格 -->
      <el-form
        ref="addform"
        :model="editform"
        label-width="90px"
      >
        <el-form-item label="address">
          <el-input v-model="editform.address" placeholder="请输入address" type="text"/>
        </el-form-item>
         <el-form-item label="privateKey">
          <el-input v-model="editform.privateKey" placeholder="请输入privateKey" type="text"/>
        </el-form-item>
         <el-form-item label="hexAddress">
          <el-input v-model="editform.hexAddress" placeholder="请输入hexAddress" type="text"/>
        </el-form-item>
        <el-form-item label="publicKey">
          <el-input v-model="editform.publicKey" placeholder="请输入publicKey" type="text"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editform.memo" placeholder="请输入备注" type="text"/>
        </el-form-item>
        <el-form-item label="设置" prop="isEnabled">
          <el-checkbox v-model="editform.isGuiji">是否归集账号</el-checkbox>
          <el-checkbox v-model="editform.isZhuanchu">是否转出账号</el-checkbox>
          <el-checkbox v-model="editform.isAutoZhuan">是否自动转出USDT</el-checkbox>
          <el-checkbox v-model="editform.isZhuanTrx">是否转出激活TRX</el-checkbox>
          <el-checkbox v-model="editform.isDailiEnergy">是否代理能量</el-checkbox>
          <el-checkbox v-model="editform.isZhuanWithdrawTrx">是否自动转出提现TRX</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="edit-button"
            :loading="buttongLoding"
            @click="editManagement"
            >更新</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 密码验证 -->
    <el-dialog
      :visible.sync="editPasswordShow"
      width="400px" 
      :center='true'
      title="请输入密码验证"
      :close-on-click-modal="false"
    >
      <div>
        <div>设置归集账号密码</div>
        <div style="margin: 15px 0;">
            <el-input v-model="editPassword" placeholder="请输入账号密码" type="text"/>
        </div>
        <div v-if="type == 1">
          <el-button
            type="primary"
            class="edit-button"
            :loading="buttongLoding"
            @click="handleDel()"
            >确认</el-button
          >
        </div>
        <div v-if="type == 2">
          <el-button
            type="primary"
            class="edit-button"
            :loading="buttongLoding"
            @click="getById()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密
export default {
  name: "Management",
  components: { Pagination },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      showtabelData: [], // 展示的表单信息
      // 添加表单
      addform: {
        address:'',
        privateKey:'',
        hexAddress:'',
        publicKey:'',
        memo:''
      },
      // 修改表单
      editform: { },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      add_dialogVisible: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加载
      buttongLoding: false, // 按钮加载
      isGuiji: false,
      isZhuanchu: false,
      isAutoZhuan: false,
      isZhuanTrx: false,
      isDailiEnergy: false,
      editPasswordShow:false,
      isZhuanWithdrawTrx:false,
      editPassword:'',
      type:1,
      id:''
    };
  },
  mounted() {
    this.getRoleinfo();
  },
  methods: {
    // 筛选
    select() {
      this.pageNum = 1;
      this.getRoleinfo();
    },
    // 获取角色列表
    getAllroles() {
      this.$api.capital
        .getAllRoles()
        .then((res) => {
          this.options = res;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        });
    },
    // 获取表单信息
    getRoleinfo() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        name: this.name,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.capital
        .tronscanMasterAccountList(params)
        .then((res) => {
          this.showtabelData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.add_dialogVisible = false
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    close(){
      this.add_dialogVisible = false
      this.edit_dialogVisible = false
      this.editPasswordShow = false
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
        password:this.editPassword
      };
      this.$api.capital
        .tronscanMasterAccountDelete(params)
        .then((res) => {
          this.$message.success(res);
          this.getRoleinfo();
          this.editPasswordShow = false
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          
        });
    },
    // 打开新增弹窗
    openAdd() {
      this.add_dialogVisible = true;
      this.addform.address = ''
      this.addform.hexAddress = ''
      this.addform.privateKey = ''
      this.addform.publicKey = ''
      this.addform.memo = ''
      this.isGuiji = false
      this.isZhuanchu = false
      this.isAutoZhuan = false
      this.isZhuanTrx = false
      this.isDailiEnergy = false
      this.isGisDailiEnergyuiji = false
      this.isZhuanWithdrawTrx = false

    },
    // 打开编辑弹窗
    edit(row) {
      this.id = row.id
      this.editPasswordShow = true;
      this.editPassword = ''
      this.type = 2
    },
    getById(){
        this.$api.capital
            .getById({id:this.id,editPassword:this.editPassword})
            .then((res) => {
                this.editPasswordShow = false;
                this.edit_dialogVisible = true;
                this.editform = res
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 生成新号
    genNew(){
        this.$api.capital
            .genNew()
            .then((res) => {
                this.addform.address = res.address
                this.addform.hexAddress = res.hexAddress
                this.addform.privateKey = res.privateKey
                this.addform.publicKey = res.publicKey
                console.log(this.addform)
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });

    },
    importWallet(row){
        this.$confirm("是否导入钱包?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.capital
            .importWallet({id:row.id})
            .then((res) => {
              this.$message.success(res);
              this.add_dialogVisible = false;
              this.getRoleinfo();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
         
      })
    },
    // 添加用户
    addManagement() {
        this.addform.isGuiji = this.isGuiji
        this.addform.isZhuanchu = this.isZhuanchu
        this.addform.isAutoZhuan = this.isAutoZhuan
        this.addform.isZhuanTrx = this.isZhuanTrx
        this.addform.isDailiEnergy = this.isDailiEnergy
        this.addform.isZhuanWithdrawTrx = this.isZhuanWithdrawTrx
        this.$api.capital
            .tronscanMasterAccountSave(this.addform)
            .then((res) => {
              this.$message.success(res);
              this.add_dialogVisible = false;
              this.getRoleinfo();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 更新用户信息
    editManagement() {
      this.$api.capital
        .tronscanMasterAccountUpdate(this.editform)
        .then((res) => {
          this.$message.success(res);
          this.getRoleinfo();
          this.edit_dialogVisible = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 打开删除弹窗
    open() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何角色");
      }
      this.editPassword = ''
      this.editPasswordShow = true
      this.type = 1
      // this.$confirm("此操作将永久删除该管理员, 是否继续?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //   // this.handleDel();
      //   this.editPassword = true
      //   this.type = 1
       
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "已取消删除",
      //     });
      //   });
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
